import { SITES, type Site } from "@hana/db";

// apps/crawler/src/crawlers.ts の ACTIVE_CRAWL_SITES (= bespokeSources のキー) のミラー。
// admin-app は @hana/crawler に依存していない (crawler は cheerio / puppeteer を抱えていて
// ブラウザバンドルに載せられない) ので、ここに手で写している。
// crawler 側に parser を足したらこの配列も必ず更新すること。
// ズレは tests/admin-sites.test.ts が検知する。
export const CRAWLER_IMPLEMENTED_SITES: readonly Site[] = [
  "moppy",
  "hapitas",
  "pointincome",
  "chobirich",
  "pointtown",
  "altema",
  "amefri",
  "au_point_program",
  "chance_it",
  "ecnavi",
  "fruitmail",
  "gendama",
  "getmoney",
  "gmo_poikatsu",
  "g_point",
  "kensho_nyandaful",
  "line_brand_catalog",
  "nifty_point_club",
  "point_hiroba",
  "point_museum",
  "pointier",
  "poikatsu_club",
  "pokema_net",
  "poney",
  "powl",
  "rakuten_point_mall",
  "rebates",
  "sugutama",
  "tamaru_mall",
  "warau",
];

// parser 未実装の site。ジョブ自体は積めるが stub subagent が空配列を返すだけなので、
// UI では実装済みと分けて表示する。
export const CRAWLER_PENDING_SITES: readonly Site[] = SITES.filter(
  (site) => !CRAWLER_IMPLEMENTED_SITES.includes(site),
);

// dropdown の初期選択。必ず実装済みの site を選んでおく。
export const DEFAULT_CRAWL_SITE: Site = CRAWLER_IMPLEMENTED_SITES[0];
